import { useState, useEffect } from "react";

export const useRadioChannelData = (slug, initialData = null) => {
  const [channelData, setChannelData] = useState(initialData);

  // Update state if we client-side navigate between valid channels
  useEffect(() => {
    setChannelData(initialData);
  }, [initialData]);

  // Quintype handles all the data loading before the page even renders.
  // If initialData is null here, it means the server explicitly told us the page doesn't exist.
  const loading = false;
  const error = !initialData ? new Error("Not found") : null;

  return { channelData, loading, error };
};
